import { render } from "./GraphicDesign.vue?vue&type=template&id=70449452"
import script from "./GraphicDesign.vue?vue&type=script&lang=js"
export * from "./GraphicDesign.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__